import React from 'react';
import { LocStr } from '../utils/Utils';
import {
  Design_the_elements,
  Round_corners,
  Select_style_elements,
  Set_appearance_brand,
  Square_corners,
  Style_str,
} from '../utils/DictionaryManagementUtils';
import RadiusMenu from '../components/PanelsComponents/Radius/RadiusMenu';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';

//= ========================================================================

const Panel_X01_themeRadius = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const cornerList = [
    {
      text: Square_corners,
      isSquare: true,
    },
    {
      text: Round_corners,
      isSquare: false,
    },
  ];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={Style_str}
      paragraph={Set_appearance_brand}
      tooltipsTitles={globJSON.configurations.theme.screens_ordering}
      disableEditElements
      language={language}
      paddingVertical={25}
    >
      <RadiusMenu
        globJSON={globJSON}
        onConfigChanged={onConfigChanged}
        headline={LocStr(Design_the_elements, language)}
        paragraph={LocStr(Select_style_elements, language)}
        list={cornerList}
      />
    </FullPagePanel>
  );
};

export default Panel_X01_themeRadius;
